import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './BulkSelectCheckbox.less';

export const BULK_SELECT_STATE_UNCHECKED = 'unchecked';
export const BULK_SELECT_STATE_CHECKED = 'checked';
export const BULK_SELECT_STATE_INDETERMINATE = 'indeterminate';

const BULK_SELECT_STATES = [
  BULK_SELECT_STATE_UNCHECKED,
  BULK_SELECT_STATE_CHECKED,
  BULK_SELECT_STATE_INDETERMINATE,
];

const BulkSelectCheckbox = ({ state, onClick, disabled, ariaLabel }) => {
  const handleClick = disabled
    ? undefined
    : (event) => {
        event.stopPropagation();
        onClick();
      };

  return (
    <div
      styleName={classNames('BulkSelectCheckbox', state, { disabled })}
      onClick={handleClick}
      role="checkbox"
      aria-checked={
        state === BULK_SELECT_STATE_INDETERMINATE ? 'mixed' : state === BULK_SELECT_STATE_CHECKED
      }
      aria-disabled={disabled}
      aria-label={ariaLabel}
      tabIndex={disabled ? -1 : 0}
    >
      <div styleName="box">
        {state === BULK_SELECT_STATE_CHECKED && (
          <svg
            styleName="check"
            width="10"
            height="8"
            viewBox="0 0 10 8"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M1 4.5L3.5 7L9 1"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        )}
        {state === BULK_SELECT_STATE_INDETERMINATE && <span styleName="dash" />}
      </div>
    </div>
  );
};

BulkSelectCheckbox.propTypes = {
  state: PropTypes.oneOf(BULK_SELECT_STATES),
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

BulkSelectCheckbox.defaultProps = {
  state: BULK_SELECT_STATE_UNCHECKED,
  disabled: false,
  ariaLabel: 'Select row',
};

BulkSelectCheckbox.displayName = 'BulkSelectCheckbox';

export default BulkSelectCheckbox;
